import { StoryblokComponent } from '@storyblok/react';
import clsx from 'clsx';

import { pageContainerProps } from '@edelman/storyblok-ui/src/utils';
import { PageContainer } from '@edelman/ui';
import { SbBlokData } from '@edelman/utils';

export const DefaultVariant = ({ blok, className, meta = {} }: SbBlokData) => {
  // Content bloks
  const { body } = blok;

  // Styles
  const variantStyles = clsx('');

  return (
    <PageContainer
      {...pageContainerProps({
        blok,
        meta,
        className: clsx(className, variantStyles),
      })}
    >
      {body?.map((nestedBlok, index: number) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} componentIndex={index} />
      ))}
    </PageContainer>
  );
};
